import i18n from '@/utils/i18n';
import OrderGuideStarIcon from '@assets/icons/order-guide-star.svg';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { ItemListOptionMetadata } from '@/contexts/item-context-types';
import { Skeleton } from 'react-native-skeletons';
import { Text, View } from 'react-native';
import { useOrderGuideItemsContext } from '@/contexts/order-guide-items-context';

interface Props {
  variantPackMetadata: ItemListOptionMetadata;
}

export const VariantPackOrderInfo: React.FC<Props> = ({
  variantPackMetadata,
}) => {
  const [styles, theme] = useStyles();
  const { isInOrderGuide, loading } = useOrderGuideItemsContext();
  const vpIsInOrderGuide = isInOrderGuide(variantPackMetadata.variantPackUUID);

  if (loading) {
    return (
      <View style={styles.base}>
        <View style={[styles.cell]}>
          <Skeleton borderRadius={16} height={16} width={16} />
          <View style={styles.cellText}>
            <Skeleton height={12} width={20} />
          </View>
        </View>
      </View>
    );
  }
  const startColor = vpIsInOrderGuide
    ? theme.sk.color.icon.positive.secondary
    : theme.sk.color.icon.warning.secondary;

  return (
    <View style={styles.base}>
      <View style={styles.cell}>
        <OrderGuideStarIcon stroke={startColor} />
        <Text
          style={[TYPOGRAPHY.small, FONTS.primarySemiBold, styles.cellText]}
        >
          {vpIsInOrderGuide ? i18n.t('yes') : i18n.t('no')}
        </Text>
      </View>
      {(variantPackMetadata.variantPackOrderCounts || []).map((item) => (
        <View key={item.days} style={styles.cell}>
          <View style={[styles.boxContainer]}>
            <Text style={[TYPOGRAPHY.tiny, FONTS.primaryBold, styles.boxText]}>
              {item.days}
            </Text>
          </View>
          <Text
            style={[TYPOGRAPHY.small, FONTS.primarySemiBold, styles.cellText]}
          >
            {item.order_count ?? '--'}
          </Text>
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    gap: 12,
    marginBottom: 8,
    marginTop: 4,
    paddingHorizontal: 4,
  },
  boxContainer: {
    alignItems: 'center',
    borderColor: theme.colors.inactiveText,
    borderRadius: 2,
    borderWidth: 1.5,
    height: 14.5,
    justifyContent: 'center',
    width: 18,
  },
  boxText: {
    color: theme.colors.inactiveText,
  },
  cell: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  cellText: {
    marginLeft: 8,
  },
}));
